import React, { useEffect, useState } from 'react';
import { bottomsubbannerList } from '../services/General-service';
import { Link } from 'react-router-dom';

function Studio() {
    const [subbannerArr, setsubBannerArr] = useState([]);

    const getsubBannerList = () => {
        bottomsubbannerList('')
            .then((data) => {
                setsubBannerArr(data.data || []);
            })
            .catch((error) => {
                console.error("Error fetching banner list:", error);
            });
    };

    useEffect(() => {
        getsubBannerList();
    }, []);

    if (!subbannerArr.length) return null;

    return (
        <div className="book-appointment-home-section">
            <div className="App">
                <div className="BreakPointContainer d_sm_none">
                    <div className="layout column align-center appointment-banner-home">
                        {subbannerArr.map((data, index) => (
                            ((index + 1) == subbannerArr.length) ? (
                                <div className="appointment-banner-container-unique" key={index}>
                                    <Link to={data.url ? `${data.url}` : '#'} {...(data.url ? { target: '_blank' } : {})}>
                                        <div className="appointment-banner-wrapper-unique">
                                            <img src={data.banner_image} alt="Book Appointment" className="appointment-banner-image-unique" />
                                        </div>
                                    </Link>
                                </div>
                            ) : (
                                <div className="mb-4 appointment-banner-container-unique" key={index}>
                                    <Link to={data.url ? `${data.url}` : '#'} {...(data.url ? { target: '_blank' } : {})}>
                                        <div className="appointment-banner-wrapper-unique">
                                            <p className="bkapnt">Book Your Appointment</p>
                                            <img src={data.banner_image} alt="Book Appointment" className="appointment-banner-image-unique" />
                                        </div>
                                    </Link>
                                </div>
                            )
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Studio;
